<style lang="stylus">
    .preview-modal-container
        border none
        overflow hidden
        width 1134px
        height 600px
        padding-bottom 0
        @media screen and (min-height: 912px)
            height 800px
            iframe
                height 800px !important

        .title-close
            top 4px
            right 0
        .header-prefix
            float left
            display flex
            align-items center
            margin 10px 0 0 12px
            font-weight 400
            > p
                margin 0 4px
                color #000
            .ivu-tooltip-arrow
                border-bottom-color rgba(0, 6, 14, 0.8) !important
            .ivu-tooltip-inner
                background-color rgba(0, 6, 14, 0.8) !important
                border-radius 8px
                p
                    line-height 20px
                    color #fff
                    font-size 12px
        .tips-mark
            cursor default
            .ivu-tooltip-rel
                display flex
        .dialog-slot
            padding 0 !important
        iframe
            display block
            width 100%
            height 600px
</style>

<template>
    <Dialog ref="dialogDom" class="preview-modal-container" :isShow="true" :mask="true" @close="closeDialog">
        <iframe ref="previewFrame" :src="url" frameborder="0"></iframe>
    </Dialog>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Dialog from "@/home/parts/Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class PreviewModal extends Vue {
        get showPreviewModalID() {
            return this.$store.state.showPreviewModalID;
        }
        get url() {
            const host = "https://www.edrawmax.cn/spa_store/file/";
            // const host = "http://10.9.0.184:2235/spa_store/file/";
            return host + `${this.showPreviewModalID}/?action=isFileFrame`;
        }
        closeDialog() {
            this.$store.commit("setState", {
                type: "showPreviewModal",
                data: false,
            });
            this.sensors.track("searchResultClickTemplatePopup", {
                Catalogues: "searchMainpage",
                action: "close",
            });
        }
        get userInfo() {
            return this.$store.getters.apiParam;
        }
        get userVip() {
            return this.vip;
        }
        postMessageToFrame(msg) {
            (this.$refs.previewFrame as HTMLIFrameElement).contentWindow.postMessage(msg, "*");
        }
        @Watch("userVip")
        checkVip(nv, ov) {
            if (nv == 1) {
                this.postMessageToFrame({ type: "vipChange" });
            }
        }
        messageHandle(e) {
            const type = e.data.type;
            if (type == "buy") {
                this.$openBuyPage();
            } else if (type == "track") {
                this.sensors.track("searchResultClickTemplatePopup", {
                    Catalogues: "searchMainpage",
                    action: "click",
                    value: e.data.name,
                });
            }
        }
        mounted() {
            this.sensors.track("searchResultClickTemplatePopup", {
                Catalogues: "searchMainpage",
                action: "open",
            });
            window.addEventListener("message", this.messageHandle);
        }
        beforeDestroy() {
            window.removeEventListener("message", this.messageHandle);
        }
    }
</script>

<i18n>
{
    "zh": {
        "title": "iconfont",
        "tips": "素材内容版权归作者及来源网站所有，未经iconfont或其关联公司书面授权许可，不得用于任何商业用途。若希望使用该素材，请提前联系作者，取得授权后再进行使用，避免造成侵犯作者知识产权。"
    },
    "en": {
        "title": "iconfont",
        "tips": "The copyright of the materials belongs to the authors and the source websites. They may not be used for any commercial purpose without the written authorization of iconfont or its affiliates.If you want to use this material, please contact the author in advance to obtain authorization before use to avoid infringing upon the author's intellectual property rights."
    },
    "fr": {
        "tips": "Les droits d'auteur des documents appartiennent aux auteurs et aux sites Web sources. Ils ne peuvent pas être utilisés à des fins commerciales sans l'autorisation écrite d'iconfont ou de ses filiales.Si vous souhaitez utiliser ce document, contactez l'auteur au préalable pour obtenir une autorisation avant utilisation afin d'éviter toute violation de ses droits de propriété intellectuelle."
    },
    "de": {
        "tips": "Das Copyright für die Materialien liegt bei den Autoren und den Quellseiten. Sie dürfen ohne die schriftliche Genehmigung von iconfont oder seinen verbundenen Unternehmen nicht für kommerzielle Zwecke verwendet werden.Wenn Sie dieses Material verwenden möchten, kontaktieren Sie bitte den Autor im Voraus, um vor der Verwendung eine Genehmigung einzuholen und so eine Verletzung der geistigen Eigentumsrechte des Autors zu vermeiden."
    },
    "jp": {
        "tips": "素材の著作権は、作成者およびソース Web サイトに帰属します。これらの素材は、iconfont またはそのアフィリエイトの書面による許可がない限り、いかなる商業目的にも使用することはできません。この素材を使用する場合は、作成者の知的財産権を侵害しないように、使用前に事前に作成者に連絡して許可を得てください。"
    },
    "es": {
        "tips": "Los derechos de autor de los materiales pertenecen a los autores y a los sitios web de origen. No podrán utilizarse con fines comerciales sin la autorización por escrito de iconfont o de sus filiales.Si desea utilizar este material, póngase en contacto con el autor con antelación para obtener autorización antes de utilizarlo y evitar así infringir sus derechos de propiedad intelectual."
    },
    "pt": {
        "tips": "Os direitos autorais dos materiais pertencem aos autores e aos sites de origem. Eles não podem ser usados para qualquer finalidade comercial sem a autorização por escrito da iconfont ou de suas afiliadas.Se você quiser usar este material, entre em contato com o autor com antecedência para obter autorização antes do uso para evitar violação dos direitos de propriedade intelectual do autor."
    },
    "it": {
        "tips": "Il copyright del materiale appartiene agli autori e ai siti web di origine. Non possono essere utilizzati per scopi commerciali senza l'autorizzazione scritta di iconfont o delle sue affiliate.Se si desidera utilizzare questo materiale, contattare l'autore in anticipo per ottenere l'autorizzazione prima dell'uso al fine di evitare di violare i diritti di proprietà intellettuale dell'autore."
    },
    "tw": {
        "tips": "資料版權歸作者及來源網站所有。未經 iconfont 或其關係企業書面授權，不得用於任何商業用途。如果您想使用此資料，請在使用前聯絡作者以取得授權，以免侵犯作者的智慧財產權。"
    },
    "kr": {
        "tips": "자료의 저작권은 저작자와 소스 웹 사이트에 있습니다. iconfont 또는 그 계열사의 서면 승인 없이는 상업적 목적으로 사용할 수 없습니다.이 자료를 사용하려면 저작자의 지적재산권을 침해하지 않도록 사전에 저작자에게 연락하여 승인을 받으시기 바랍니다."
    }
}
</i18n>
